<div class="minimal-modal-wrapper p-4 text-center">
    <button type="button" class="btn-close-minimal" (click)="dismiss()" aria-label="Close">
        <span class="material-symbols-outlined">close</span>
    </button>

    <div class="icon-container mb-3">
        <div class="icon-shape">
            <span class="material-symbols-outlined">inventory_2</span>
        </div>
    </div>

    <h3 class="modal-title-clean">Conferma Ingestione</h3>
    <p class="modal-text mb-1">
        Stai per avviare l'elaborazione dei documenti nell'indice:
    </p>
    
    <div class="index-highlight mb-4">
        {{ indexName }}
    </div>

    <div class="modal-actions d-flex justify-content-center gap-3">
        <button type="button" class="btn-cancel" (click)="dismiss()">
            Annulla
        </button>
        <button type="button" class="btn-confirm" (click)="confirm()">
            Conferma e Avvia
        </button>
    </div>
</div>